import { render, staticRenderFns } from "./ComponenteCrud.vue?vue&type=template&id=54600d1a&lang=es"
import script from "./ComponenteCrud.vue?vue&type=script&lang=js"
export * from "./ComponenteCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports